import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API, Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import './Level1.scss';
import Icon_volume from './../icon_volume.svg'
import Record from '../Record/Record';
import StorePage from '../Store/Store'
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import Coin from '../Coin/Coin'
import Celebrate from '../Celebrate/Celebrate';
import Surprise from '../SurpriseVideo/surprise';
import Game from '../PressYourLuck/Game'
import Animal from '../Animal/Animal'
import Store from '../Store/store.jpg'
import Draggable from 'react-draggable';
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"

const Level1 = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const firstUpdate = useRef(true);
    const dispatch = useDispatch();
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;


    const [clientHeight, setVh] = useState(window.innerHeight);
    const [clientWidth, setVw] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setVh(window.innerHeight);
        setVw(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [clientHeight, clientWidth]);

    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const navigate = useNavigate();
    const [displayDecorate, setDisplayDecorate] = useState(props.decorate || props.store);
    const [displayStep1, setDisplayStep1] = useState(!props.decorate && !props.achievement && !props.store);
    const [displayStep2, setDisplayStep2] = useState(false);
    const [displayStep3, setDisplayStep3] = useState(false);
    const [displayStore, setDisplayStore] = useState(props.store);
    const [displayStoreCharacter, setDisplayStoreCharacter] = useState(false);
    const [storeReady, setStoreReady] = useState(false);

    const [displayCoin, setDisplayCoin] = useState(false);
    const [displayCelebrate, setDisplayCelebrate] = useState(false);
    const [displayCoinAfterCelebrate, setDisplayCoinAfterCelebrate] = useState(false);
    const [displayGame, setDisplayGame] = useState(false);
    const [displayAnimal, setDisplayAnimal] = useState(false);
    const [displaySurpriseVideoIcon, setDisplaySurpriseVideoIcon] = useState(false);
    const [displaySurpriseVideo, setDisplaySurpriseVideo] = useState(false);
    const [surpriseVideo, setSurpriseVideo] = useState("");
    const [prize, setPrize] = useState(false);
    const [disPlayPrize, setDisplayPrize] = useState(false);

    const [animal, setAnimal] = useState('');
    const [animals, setAnimals] = useState([]);
    const [celebrateVoice, setCelebrateVoice] = useState('');
    const [celebrateText, setCelebrateText] = useState('');
    const [topicName, setTopicName] = useState('');

    const [change, setChange] = useState(false);


    const [practice, setPractice] = useState(false);

    const [topics, setTopics] = useState(null);

    const [conversationNum, setConversationNum] = useState(-1);
    const [conversationName, setConversationName] = useState('');
        
    const influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4,login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]

    const giftBtn = generateImageUrl('images/Images/Gift.png');
    const playIcon = generateImageUrl('images/newDesign/FreePlay/play.png')
    const rewardSound = new Audio(presentSound);

    const updateFreeplay = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				name: "level1",
				coin: freeplay.level1Coin,
				progress: JSON.stringify(freeplay.level1),
                decorate: JSON.stringify(freeplay.level1Decorate)
			},
		}
		await API.put('TIR', '/v3/student/freeplay', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
        const myInit2 = {
            body: {
              id: login.studentid,
              current_module: 'Level1',
            },
          };
          await API.put('TIR', '/v3/student', myInit2)
          .then((response) => {
          })
          .catch((error) => {
          });
	})

    const updateProgress = (async () => {
        const getNestedLength = (obj) => {
            let length = 0;
            Object.values(obj).forEach(value => {
                Object.values(value).forEach(module => {
                    if (module.unlocked === 1) {
                        length += 1
                    }
                });
            });
            return length;
        };
        const totalLength = getNestedLength(freeplay.level1);
		const payload = {
			body: {
				id: login.studentid,
				module: `Level1`,
				day_completed: totalLength,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

    const getAnimalData = async (levelName, unlockedCount, animalName) =>  {
        if (Object.values(freeplay.level1[levelName]).filter(value => value.unlocked === 1).length === unlockedCount) {
            let photo;
            await GetUserVideo(`userfiles/${login.studentid}/level1_${levelName}_animal.png`).then((data) => {
                photo = data 
            });
            fetch(photo).then((response) => {
                if (response.status === 200) {
                    let item = {
                        img: photo,
                        name: levelName,
                        animal: animalName,
                        coin: 0
                    };

                    // Update the boughts array
                    boughts.forEach(existingItem => {
                        if (existingItem.name === levelName) {
                            existingItem.url = photo;
                        }
                    });

                    // Update or add item in the animals array
                    const foundItem = animals.find(existingItem => existingItem.name === levelName);
                    if (foundItem) {
                        foundItem.img = photo;
                    } else {
                        animals.push(item);
                    }

                    // Update the state
                    setBoughts(boughts);
                    setAnimals(animals);
                }
            });
        }
    };
    
    const getAnimals = async () => {
        const animalConfigurations = [
            { levelName: "favorite", unlockedCount: 5, animalName: "crab" },
            { levelName: "feeling", unlockedCount: 6, animalName: "dog"},
            { levelName: "listening", unlockedCount: 6, animalName: "lizzard"},
            { levelName: "friends", unlockedCount: 5, animalName: "monkey"},
            { levelName: "solution", unlockedCount: 3, animalName: "bird"},
            { levelName: "conflict", unlockedCount: 5, animalName: "lion"},
            { levelName: "advocacy", unlockedCount: 5, animalName: "elephant"},
            { levelName: "community", unlockedCount: 10, animalName: "toucan"}
        ];
    
        // Iterate over each animal configuration and call the function
        for (const config of animalConfigurations) {
            try{
                await getAnimalData(config.levelName, config.unlockedCount, config.animalName);
            }
            catch(error){}       
        }

        setStoreReady(true);

    };
    
    useEffect(() => {
        const fetchData = async () => {
            let modules = ['favorite', 'feeling', 'listening', 'friends', 'solution', 'conflict', 'advocacy', 'community'];
            
            // Loop through boughts and fetch data if necessary
            for (let item of boughts) {
                if (modules.includes(item.name)) {
                    try {
                        // Await the fetch to check the URL status
                        const response = await fetch(item.url);
                        // If the response is not OK (status !== 200), fetch the new image
                        if (response.status !== 200) {
                            const data = await GetUserVideo(`userfiles/${login.studentid}/level1_${item.name}_animal.png`);
                            item.url = data; // Directly update the URL property
                        }
                    } catch (error) {
                        // In case of an error, attempt to get the video
                        const data = await GetUserVideo(`userfiles/${login.studentid}/level1_${item.name}_animal.png`);
                        item.url = data; // Directly update the URL property
                    }
                }
            }
            
            // After processing all items, update the state with a new reference
            setBoughts([...boughts]); // Trigger re-render with updated state
        };
        fetchData();
    }, []);

    useEffect(() => {
        if(displayStore){
            getAnimals();
        }
    }, [displayStore]);

    const backgrounds = [generateImageUrl('images/Module1Images/U1M1_Background_Landscape.png'), 
                         generateImageUrl('images/Module2Images/U1M2_DayScene_Landscape.png'),
                         generateImageUrl('images/Module3Images/U1M3_DayScene_Landscape.png'),
                         generateImageUrl('images/newDesign/Unit1Module4/World4Large.png'),
                         generateImageUrl('images/Module5Images/bg_only.png')]
    const [bgIdx, setBgIdx] = useState(freeplay.level1Decorate.background);

    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
    const greenCheckSound = new Audio(generateImageUrl('media/Module1Videos/button_accept_item.mp3'))
    const Exit = generateImageUrl('images/Images/close.png')
    const coin = generateImageUrl('images/Images/Coin_Empty.png');


    let buys = [
        {
            img: 'images/Module1Images/Reward_ChairBlue.svg',
            name: "BeachChairBlue",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_ChairRed.svg',
            name: "BeachChairRed",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Shoes.svg',
            name: "BeachwearSandles",
            coin: 4
        },
        {
            img: 'images/Module1Images/Reward_Googels.svg',
            name: "BeachwearSnorkle",
            coin: 4
        },
        {
            img: 'images/Module1Images/Reward_BeachBall.svg',
            name: "FloatationBall",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Bucket.svg',
            name: "SandBucket",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Glasses.svg',
            name: "CrabWearGlasses",
            coin: 8
        },
        {
            img: 'images/Module1Images/Reward_Mustache.svg',
            name: "CrabWearMustache",
            coin: 8
        },
        {
            img: 'images/Module1Images/Reward_SandCastel.svg',
            name: "SandCastle",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_StarFish.svg',
            name: "SeashellsRed",
            coin: 4
        },
        {
            img: 'images/Module1Images/Reward_Ship.svg',
            name: "OceanBoat",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Shell.svg',
            name: "SeashellsGreen",
            coin: 4
        },
        {
            img: 'images/Module1Images/Reward_SurfBoardBlue.svg',
            name: "SurfBoardBlue",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_SurfBoardRed.svg',
            name: "SurfBoardRed",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_UmbrellaGreen.svg',
            name: "UmbrellaGreen",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_UmbrellaRed.svg',
            name: "UmbrellaRed",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Floaty.svg',
            name: "FloatationInnerTube",
            coin: 6
        },
        {
            img: 'images/Module1Images/Reward_Whale.svg',
            name: "OceanWhale",
            coin: 6
        },
        {
            img: 'images/Module2Images/Reward_Ball.png',
            name: "Ball",
            coin: 4
        },
        {
            img: 'images/Module2Images/Reward_ButterflyBlue.png',
            name: "ButterflyBlue",
            coin: 4
        },
        {
            img: 'images/Module2Images/Reward_ButterflyPink.png',
            name: "ButterflyPink",
            coin: 4
        },
        {
            img: 'images/Module2Images/Reward_Flowers.png',
            name: "Flowers",
            coin: 4
        },
        {
            img: 'images/Module2Images/Reward_KitePink.png',
            name: "KitePink",
            coin: 6
        },
        {
            img: 'images/Module2Images/Reward_KitePurple.png',
            name: "KitePurple",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/Reward_MerryGoAround.svg',
            name: "MerryGoRound",
            coin: 10
        },
        {
            img: 'images/newDesign/FreePlay/rewards/pond.png',
            name: "Pond",
            coin: 10
        },
        {
            img: 'images/Module5Images/tree.png',
            name: "Tree",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_SandPit.png',
            name: "Sandbox",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_BikeSpringChair.png',
            name: "SpringToy",
            coin: 10
        },
        {
            img: 'images/newDesign/FreePlay/rewards/Reward_Swing.svg',
            name: "Swingset",
            coin: 10
        },
        {
            img: 'images/newDesign/FreePlay/rewards/bowTie.svg',
            name: "Bow",
            coin: 8
        },
        {
            img: 'images/Module2Images/Reward_Hat.png',
            name: "Hat",
            coin: 8
        },
        {
            img: 'images/Module2Images/Reward_MonkeyBarsBlue.png',
            name: "MonkeybarsBlue",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_MonkeyBarYellow.png',
            name: "MonkeybarsYellow",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_RedSlide.png',
            name: "SlideRed",
            coin: 10
        },
        {
            img: 'images/Module2Images/Reward_YellowSlide.png',
            name: "SlideYellow",
            coin: 10
        },
        {
            img: 'images/Module3Images/Reward_Backpack.png',
            name: "Backpack",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_CowboyBoots.png',
            name: "BootsCowboy",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_HikingBoots.png',
            name: "BootsHiking",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_TallCactus1.png',
            name: "CactusTall",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_TallCactus2.png',
            name: "CactusTall2",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Cantina.png',
            name: "Canteen",
            coin: 4
        },
        {
            img: 'images/Module3Images/Reward_Fire.png',
            name: "Fire",
            coin: 4
        },
        {
            img: 'images/Module3Images/Reward_Bird1.png',
            name: "Hawk",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Lamp.png',
            name: "Lantern",
            coin: 4
        },
        {
            img: 'images/newDesign/FreePlay/rewards/cresentMoon.png',
            name: "MoonCresent",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/fullMoon.png',
            name: "MoonFull",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Bird2.png',
            name: "Owl",
            coin: 6
        },
        {
            img: 'images/Module3Images/Reward_Tent1.png',
            name: "Tent",
            coin: 10
        },
        {
            img: 'images/Module3Images/Reward_Tent2.png',
            name: "TentOld",
            coin: 10
        },
        {
            img: 'images/newDesign/FreePlay/rewards/cowboyHat.png',
            name: "Hat",
            coin: 8
        },
        {
            img: 'images/newDesign/FreePlay/rewards/bandana.png',
            name: "Bandanna",
            coin: 8
        },
        {
            img: 'images/Module4Images/Reward_Binoculars.png',
            name: "Binoculars",
            coin: 4
        },
        {
            img: 'images/Module4Images/Reward_Camera.png',
            name: "Camera",
            coin: 4
        },
        {
            img: 'images/Module4Images/Reward_Cheetah.png',
            name: "Cheetah",
            coin: 12
        },
        {
            img: 'images/Module4Images/Reward_DrumBlue.png',
            name: "DrumBlue",
            coin: 4
        },
        {
            img: 'images/Module4Images/Reward_DrumRed.png',
            name: "DrumPink",
            coin: 4
        },
        {
            img: 'images/Module4Images/Reward_Flamingo.png',
            name: "Flamingos",
            coin: 12
        },
        {
            img: 'images/Module4Images/Reward_Giraffe.png',
            name: "Giraffe",
            coin: 12
        },
        {
            img: 'images/Module4Images/Reward_Hat.png',
            name: "Hat",
            coin: 8
        },
        {
            img: 'images/newDesign/FreePlay/rewards/hippo.png',
            name: "Hippo",
            coin: 12
        },
        {
            img: 'images/Module4Images/Reward_Car2.png',
            name: "JeepBlue",
            coin: 10
        },
        {
            img: 'images/Module4Images/Reward_Car.png',
            name: "JeepPink",
            coin: 10
        },
        {
            img: 'images/Module4Images/Reward_Emu.png',
            name: "Ostrich",
            coin: 6
        },
        {
            img: 'images/Module4Images/Reward_BirdColors.png',
            name: "Parrot",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/tucan.png',
            name: "Tucan",
            coin: 6
        },
        {
            img: 'images/Module4Images/Reward_Zebras.png',
            name: "Zebras",
            coin: 12
        },
        {
            img: 'images/newDesign/FreePlay/rewards/buck.png',
            name: "Deer",
            coin: 12
        },
        {
            img: 'images/Module5Images/Reward_DeerFemale.png',
            name: "Doe",
            coin: 12
        },
        {
            img: 'images/newDesign/FreePlay/rewards/colerfulDuck.png',
            name: "DuckColored",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/whiteDuck.png',
            name: "DuckWhite",
            coin: 6
        },
        {
            img: 'images/newDesign/FreePlay/rewards/bird_blue.png',
            name: "BirdBlue",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_BirdRed.png',
            name: "BirdRed",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_LadderStraight.png',
            name: "Ladder",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_LadderWave.png',
            name: "Stairs",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_WoodenSwing.png',
            name: "Swing",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_TelescopeBlue.png',
            name: "TelescopeBlue",
            coin: 4
        },
        {
            img: 'images/Module5Images/Reward_TelescopeRed.png',
            name: "TelescopeRed",
            coin: 4
        },
        {
            img: 'images/Module5Images/Reward_TireSwing.png',
            name: "TireSwing",
            coin: 6
        },
        {
            img: 'images/Module5Images/Reward_BirdhouseBlue.png',
            name: "TreeHouseBlue",
            coin: 10
        },
        {
            img: 'images/Module5Images/Reward_BirdhousePink.png',
            name: "TreeHouseRed",
            coin: 10
        }
    ]
    buys = buys.sort((a, b) => a.coin - b.coin);

    const [boughts, setBoughts] = useState(freeplay.level1Decorate.items);

    const [update, setUpdate] = useState(false);


    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        } else {
            updateFreeplay();
        }
    }, [freeplay.level1Coin, freeplay.level1, update]);

    const setConversation = (num, name) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        setConversationName(name);
        setConversationNum(num);
        chooseConversation(num);
    }

    const settopic = (num) => {
        document.querySelectorAll('.option').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('option')[num]
        element.style.border= '2px solid yellow';
        chooseTopic(num)
    }

    const chooseConversation = (conversationPlay) => {
        setDisplayStep1(false)
        let topics = [];
        switch(conversationPlay){
            case 0:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/color.png'),
                        text: "Color",
                        completed: freeplay.level1.favorite.color.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level1.favorite.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level1.favorite.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/game.png'),
                        text: "Game",
                        completed: freeplay.level1.favorite.game.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Thing to do outside",
                        completed: freeplay.level1.favorite.thing.unlocked

                    }
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/greet/greet_celebrate_record_awesome.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am awesome!"')
                if (Object.values(freeplay.level1.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.favorite).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 1:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level1.feeling.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level1.feeling.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level1.feeling.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level1.feeling.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level1.feeling.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level1.feeling.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I am amazing!"')
                if (Object.values(freeplay.level1.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.feeling).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 2:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Happy_resized.png"),
                        text: "Happy",
                        completed: freeplay.level1.listening.happy.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level1.listening.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Calm_resized.png"),
                        text: "Calm",
                        completed: freeplay.level1.listening.calm.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level1.listening.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Confident_resized.png"),
                        text: "Confident",
                        completed: freeplay.level1.listening.confident.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level1.listening.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/close/close_celebrate_record_believe.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I believe in me!"')
                if (Object.values(freeplay.level1.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.listening).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 3:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_subject.png'),
                        text: "Favorite subject in school",
                        completed: freeplay.level1.friends.subject.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/outside.png'),
                        text: "Outside",
                        completed: freeplay.level1.friends.outside.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/animal.png'),
                        text: "Animal",
                        completed: freeplay.level1.friends.animal.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/food.png'),
                        text: "Food",
                        completed: freeplay.level1.friends.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/favorite_fun.png'),
                        text: "What you like to do for fun",
                        completed: freeplay.level1.friends.fun.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level1.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.friends).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 4:
                topics = [
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Sad_resized.png"),
                        text: "Sad",
                        completed: freeplay.level1.solution.sad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Mad_resized.png"),
                        text: "Mad",
                        completed: freeplay.level1.solution.mad.unlocked

                    },
                    {
                        img: generateImageUrl("images/newDesign/FreePlay/topics/crab/Nervous_resized.png"),
                        text: "Nervous",
                        completed: freeplay.level1.solution.nervous.unlocked

                    },
                ];
                setTopics(topics);
                setCelebrateVoice(getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login))
                setCelebrateText('Record yourself in an excited voice and say, "I can do it all!"')
                if (Object.values(freeplay.level1.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.solution).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 5:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/seat_taken.png'),
                        text: "Seat Taken",
                        completed: freeplay.level1.conflict.seat.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/dino_toy.png'),
                        text: "Dislike Toy",
                        completed: freeplay.level1.conflict.shop.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/shovel.png'),
                        text: "Stole Shovel",
                        completed: freeplay.level1.conflict.shovel.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module8Images/Module8NavImages/JourneyMap_Mod3_Day8.png'),
                        text: "Blocking View",
                        completed: freeplay.level1.conflict.stand.unlocked

                    },
                    {
                        img: generateImageUrl('images/Module4Images/Reward_Camera.png'),
                        text: "Bumped Into",
                        completed: freeplay.level1.conflict.photo.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level1.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.conflict).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 6:
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/feed_birds.png'),
                        text: "Feed the Birds",
                        completed: freeplay.level1.advocacy.bird.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/buy_tickets.png'),
                        text: "Buy a Ticket",
                        completed: freeplay.level1.advocacy.train.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_monkey.png'),
                        text: "Ask a Question",
                        completed: freeplay.level1.advocacy.monkey.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/teacher.jpg'),
                        text: "Ask for Teacher",
                        completed: freeplay.level1.advocacy.care.unlocked 

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/ask_napkin.png'),
                        text: "Ask for Napkin",
                        completed: freeplay.level1.advocacy.snack.unlocked

                    }
                ];
                setTopics(topics);
                if (Object.values(freeplay.level1.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.advocacy).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            case 7:
                // Objects to be pushed into the array
                topics = [
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/snow_cone.png'),
                        text: "Snow Cone Stand",
                        completed: freeplay.level1.community.cone.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/beach_topics.png'),
                        text: "Beach",
                        completed: freeplay.level1.community.guard.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/theme_park_topic.png'),
                        text: "Theme Park",
                        completed: freeplay.level1.community.wheel.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/arcade_topic.png'),
                        text: "Arcade",
                        completed: freeplay.level1.community.arcade.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/fast_food_topic.png'),
                        text: "Fast Food",
                        completed: freeplay.level1.community.food.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/groceries_topic.png'),
                        text: "Grocery Store",
                        completed: freeplay.level1.community.grocery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/saloon_topic.png'),
                        text: "Salon",
                        completed: freeplay.level1.community.salon.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/clothing_topic.png'),
                        text: "Clothing Store",
                        completed: freeplay.level1.community.clothing.unlocked
                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/bakery_topic.png'),
                        text: "Bakery",
                        completed: freeplay.level1.community.bakery.unlocked

                    },
                    {
                        img: generateImageUrl('images/newDesign/FreePlay/topics/cinema_topic.png'),
                        text: "Movie Theater",
                        completed: freeplay.level1.community.theater.unlocked

                    },
                ];
                setTopics(topics);
                if (Object.values(freeplay.level1.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.community).length){
                    setDisplaySurpriseVideoIcon(true);
                }
                break;
            default:
                break;
        }
        setDisplayStep2(true)
    }

    const chooseTopic = (topicPlay) => {
        setDisplayStep2(false);
        let names = [];
        let instructions = [];
        let texts = [];
        let voices = [];
        let exampleVideos = [];
        let codes = [];
        let celebrateAudios = [];
        let celebrateTexts = [];
        let stepPrompts = [];
        let topicNames = [];
        switch(conversationNum){
            case 0:
                names = [
                    [
                        `level1_favorite_color_greet.mp4`,
                        `level1_favorite_color_response.mp4`,
                        `level1_favorite_color_ask.mp4`,
                        `level1_favorite_color_acknowledge.mp4`,
                        `level1_favorite_color_close.mp4`,
                    ],
                    [
                        `level1_favorite_animal_greet.mp4`,
                        `level1_favorite_animal_response.mp4`,
                        `level1_favorite_animal_ask.mp4`,
                        `level1_favorite_animal_acknowledge.mp4`,
                        `level1_favorite_animal_close.mp4`,
                    ],
                    [
                        `level1_favorite_food_greet.mp4`,
                        `level1_favorite_food_response.mp4`,
                        `level1_favorite_food_ask.mp4`,
                        `level1_favorite_food_acknowledge.mp4`,
                        `level1_favorite_food_close.mp4`,
                    ],
                    [
                        `level1_favorite_game_greet.mp4`,
                        `level1_favorite_game_response.mp4`,
                        `level1_favorite_game_ask.mp4`,
                        `level1_favorite_game_acknowledge.mp4`,
                        `level1_favorite_game_close.mp4`,
                    ],
                    [
                        `level1_favorite_outside_greet.mp4`,
                        `level1_favorite_outside_response.mp4`,
                        `level1_favorite_outside_ask.mp4`,
                        `level1_favorite_outside_acknowledge.mp4`,
                        `level1_favorite_outside_close.mp4`,
                    ],
                ];
                instructions = [
                    [
                        `appfiles/close/close_greeting_5.mp4`,
                        `appfiles/close/close_question_5.mp4`,
                        `appfiles/close/close_acknowledge_5.mp4`,
                        `appfiles/close/close_response_5.mp4`,
                        `appfiles/close/close_close_5.mp4`
                    ],
                    [
                        `appfiles/close/close_greeting_6.mp4`,
                        `appfiles/close/close_question_6.mp4`,
                        `appfiles/close/close_acknowledge_6.mp4`,
                        `appfiles/close/close_response_6.mp4`,
                        `appfiles/close/close_close_6.mp4`
                    ],
                    [
                        `appfiles/close/close_greeting_7.mp4`,
                        `appfiles/close/close_question_7.mp4`,
                        `appfiles/close/close_acknowledge_7.mp4`,
                        `appfiles/close/close_response_7.mp4`,
                        `appfiles/close/close_close_7.mp4`
                    ],
                    [
                        `appfiles/close/close_greeting_8.mp4`,
                        `appfiles/close/close_question_8.mp4`,
                        `appfiles/close/close_acknowledge_8.mp4`,
                        `appfiles/close/close_response_8.mp4`,
                        `appfiles/close/close_close_8.mp4`
                    ],
                    [
                        `appfiles/close/close_greeting_9.mp4`,
                        `appfiles/close/close_question_9.mp4`,
                        `appfiles/close/close_acknowledge_9.mp4`,
                        `appfiles/close/close_response_9.mp4`,
                        `appfiles/close/close_close_9.mp4`
                    ]
                ];
                texts = [
                    [
                        'Say, "Hi!"',
                        'Say, "My favorite color is ________."',
                        'Ask Mrs. Johnson, "What is your favorite color?"',
                        'Press record and say, "Cool!"',
                        'Press record and say, "Goodbye!"',
                    ],
                    [
                        'Say, "Hello!"',
                        'Say, "My favorite animal is ________."',
                        'Ask Mrs. Johnson, "What is your favorite animal?"',
                        'Press record and say, "Awesome!"',
                        'Press record and say, "See you later!"',
                    ],
                    [
                        'Say, "Good morning, Mrs. Johnson!"',
                        'Say, "My favorite food is ________."',
                        'Ask Mrs. Johnson, "What is your favorite food?"',
                        'Press record and say, "Yummy!"',
                        'Press record and say, "Bye!"',
                    ],
                    [
                        'Say, "Good afternoon!"',
                        'Say, "My favorite game is ________."',
                        'Ask Mrs. Johnson, "What is your favorite game?"',
                        'Press record and say, "Fun!"',
                        'Press record and say, "See you soon!"',
                    ],
                    [
                        'Say, "It is good to see you!"',
                        'Say, "My favorite thing to do outside is ________."',
                        'Ask Mrs. Johnson, "What is your favorite thing to do outside?"',
                        'Press record and say, "That is great!"',
                        'Press record and say, "Have a great day!"',
                    ],
                ];
                voices = [
                    [
                        `appfiles/greet/greet_practice_record_5.mp3`,
                        `appfiles/answer/answer_practice_record_5.mp3`,
                        `appfiles/ask/ask_practice_record_5.mp3`,
                        `appfiles/respond/respond_practice_record_5.mp3`,
                        `appfiles/close/close_practice_record_5.mp3`,
                    ],
                    [
                        `appfiles/greet/greet_practice_record_6.mp3`,
                        `appfiles/answer/answer_practice_record_6.mp3`,
                        `appfiles/ask/ask_practice_record_6.mp3`,
                        `appfiles/respond/respond_practice_record_6.mp3`,
                        `appfiles/close/close_practice_record_6.mp3`,
                    ],
                    [
                        `appfiles/greet/greet_practice_record_7.mp3`,
                        `appfiles/answer/answer_practice_record_7.mp3`,
                        `appfiles/ask/ask_practice_record_7.mp3`,
                        `appfiles/respond/respond_practice_record_7.mp3`,
                        `appfiles/close/close_practice_record_7.mp3`,
                    ],
                    [
                        `appfiles/greet/greet_practice_record_8.mp3`,
                        `appfiles/answer/answer_practice_record_8.mp3`,
                        `appfiles/ask/ask_practice_record_8.mp3`,
                        `appfiles/respond/respond_practice_record_8.mp3`,
                        `appfiles/close/close_practice_record_8.mp3`,
                    ],
                    [
                        `appfiles/greet/greet_practice_record_9.mp3`,
                        `appfiles/answer/answer_practice_record_9.mp3`,
                        `appfiles/ask/ask_practice_record_9.mp3`,
                        `appfiles/respond/respond_practice_record_9.mp3`,
                        `appfiles/close/close_practice_record_9.mp3`,
                    ]
                ];
                exampleVideos = [
                    'appfiles/freeplay/favorite/demo_color.mp4',
                    'appfiles/freeplay/favorite/demo_animal.mp4',
                    'appfiles/freeplay/favorite/demo_food.mp4',
                    'appfiles/freeplay/favorite/demo_game.mp4',
                    'appfiles/freeplay/favorite/demo_outside.mp4',
                ];
                topicNames = [
                    'Color',
                    'Animal',
                    'Food',
                    'Game',
                    'Thing to do outside',
                ];
                codes = [
                    'COLOR',
                    'ANIMAL',
                    'FOOD',
                    'GAME',
                    'THING',
                ];
                setPractice(
                    <Record
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      instructions={instructions[topicPlay]}
                      names={names[topicPlay]}
                      texts={texts[topicPlay]}
                      voices={voices[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/greet/greet_practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL1"}
                      conversation={'FAVORITE'}
                      title={"Favorite Things"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}
                    />
                  );
                setTopicName(`FAVORITE_${codes[topicPlay]}`)
                break;
            case 1:
                names = [
                    [
                        `level1_feeling_happy_answer.mp4`,
                        `level1_feeling_happy_acknowledge.mp4`,
                    ],
                    [
                        `level1_feeling_sad_answer.mp4`,
                        `level1_feeling_sad_acknowledge.mp4`,
                    ],
                    [
                        `level1_feeling_calm_answer.mp4`,
                        `level1_feeling_calm_acknowledge.mp4`,
                    ],
                    [
                        `level1_feeling_mad_answer.mp4`,
                        `level1_feeling_mad_acknowledge.mp4`,
                    ],
                    [
                        `level1_feeling_confident_answer.mp4`,
                        `level1_feeling_confident_acknowledge.mp4`,
                    ],
                    [
                        `level1_feeling_nervous_answer.mp4`,
                        `level1_feeling_nervous_acknowledge.mp4`,
                    ],
                ];
                instructions = [
                    [
                        'appfiles/freeplay/feeling/intro_happy.mp4',
                        'appfiles/freeplay/feeling/response_happy.mp4',
                    ],
                    [
                        'appfiles/freeplay/feeling/intro_sad.mp4',
                        'appfiles/freeplay/feeling/response_sad.mp4',
                    ],
                    [
                        'appfiles/freeplay/feeling/intro_calm.mp4',
                        'appfiles/freeplay/feeling/response_calm.mp4',
                    ],
                    [
                        'appfiles/freeplay/feeling/intro_mad.mp4',
                        'appfiles/freeplay/feeling/response_mad.mp4',
                    ],
                    [
                        'appfiles/freeplay/feeling/intro_confident.mp4',
                        'appfiles/freeplay/feeling/response_confident.mp4',
                    ],
                    [
                        'appfiles/freeplay/feeling/intro_nervous.mp4',
                        'appfiles/freeplay/feeling/response_nervous.mp4',
                    ],
                ];
                texts = [
                    [
                        'Press record and say, "I feel happy when I ride my bike!"',
                        'Press record and say, "Thanks so much!"',
                    ],
                    [
                        'Press record and say, "I feel sad when someone hurts my feelings!"',
                        'Press record and say, "Thanks for understanding!"',
                    ],
                    [
                        'Press record and say, "I feel calm when I listen to music!"',
                        'Press record and say, "Thank you!"',
                    ],
                    [
                        'Press record and say, "I feel mad when I break something!"',
                        'Press record and say, "Thanks for listening!"',
                    ],
                    [
                        'Press record and say, "I feel confident when I do hard things!"',
                        'Press record and say, "Thank you very much!"',
                    ],
                    [
                        'Press record and say, "I feel nervous when I have to take a test!"',
                        'Press record and say, "Thanks for asking!"',
                    ],
                ];
                voices = [
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_happy_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_happy_2.m4a'
                    ],
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_sad_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_sad_2.m4a'
                    ],
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_calm_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_calm_2.m4a'
                    ],
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_mad_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_mad_2.m4a'
                    ],
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_confident_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_confident_2.m4a'
                    ],
                    [
                        'appfiles/freeplay/feeling/practice_record_prompt_nervous_1.m4a',
                        'appfiles/freeplay/feeling/practice_record_prompt_nervous_2.m4a'
                    ],

                ]
                exampleVideos = [
                    'appfiles/freeplay/feeling/demo_happy.mp4',
                    'appfiles/freeplay/feeling/demo_sad.mp4',
                    'appfiles/freeplay/feeling/demo_calm.mp4',
                    'appfiles/freeplay/feeling/demo_mad.mp4',
                    'appfiles/freeplay/feeling/demo_confident.mp4',
                    'appfiles/freeplay/feeling/demo_nervous.mp4',
                ];
                topicNames = [
                    'Happy',
                    'Sad',
                    'Calm',
                    'Mad',
                    'Confident',
                    'Nervous',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setPractice(
                    <Record
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      instructions={instructions[topicPlay]}
                      names={names[topicPlay]}
                      texts={texts[topicPlay]}
                      voices={voices[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/greet/greet_practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL1"}
                      conversation={'FEELING'}
                      title={"Talk about Feelings"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}
                    />
                  );
                setTopicName(`FEELING_${codes[topicPlay]}`)
                break;
            case 2:
                names = [
                    [
                        `level1_listening_happy_acknowledge.mp4`,
                    ],
                    [
                        `level1_listening_sad_acknowledge.mp4`,
                    ],
                    [
                        `level1_listening_calm_acknowledge.mp4`,
                    ],
                    [
                        `level1_listening_mad_acknowledge.mp4`,
                    ],
                    [
                        `level1_listening_confident_acknowledge.mp4`,
                    ],
                    [
                        `level1_listening_nervous_acknowledge.mp4`,
                    ],
                ];
                instructions = [
                    [
                        'appfiles/active_listening/practice_new_friend.mp4',
                    ],
                    [
                        'appfiles/active_listening/practice_hurt_knee.mp4',
                    ],
                    [
                        'appfiles/active_listening/practice_music.mp4',
                    ],
                    [
                        'appfiles/active_listening/practice_hungry.mp4',
                    ],
                    [
                        'appfiles/active_listening/practice_best.mp4',
                    ],
                    [
                        'appfiles/active_listening/practice_dark.mp4',
                    ],
                ];
                texts = [
                    [
                        'Press record and say, "I am glad you feel happy because you made a new friend!"',
                    ],
                    [
                        'Press record and say, "I am sorry you feel sad because you hurt your knee."',
                    ],
                    [
                        'Press record and say, "I am glad you feel calm because you listened to music!"',
                    ],
                    [
                        'Press record and say, "I am sorry you feel mad because you are hungry."',
                    ],
                    [
                        'Press record and say, "I am glad you feel confident because you did your best!"',
                    ],
                    [
                        'Press record and say, "I am sorry you feel nervous because it is dark."',
                    ],
                ];
                voices = [
                    [
                        'appfiles/active_listening/practice_record_prompt_happy_new_friend.mp3',
                    ],
                    [
                        'appfiles/active_listening/practice_record_prompt_hurt_knee.mp3',
                    ],
                    [
                        'appfiles/active_listening/practice_record_prompt_calm_music.mp3',
                    ],
                    [
                        'appfiles/active_listening/practice_record_prompt_mad_hungry.mp3',
                    ],
                    [
                        'appfiles/active_listening/practice_record_prompt_confident_did_best.mp3',
                    ],
                    [
                        'appfiles/active_listening/practice_record_prompt_nervous_dark.mp3',
                    ],
                ];
                exampleVideos = [
                    'appfiles/freeplay/listening/demo_happy.mp4',
                    'appfiles/freeplay/listening/demo_sad.mp4',
                    'appfiles/freeplay/listening/demo_calm.mp4',
                    'appfiles/freeplay/listening/demo_mad.mp4',
                    'appfiles/freeplay/listening/demo_confident.mp4',
                    'appfiles/freeplay/listening/demo_nervous.mp4',
                ];
                topicNames = [
                    'Happy',
                    'Sad',
                    'Calm',
                    'Mad',
                    'Confident',
                    'Nervous',
                ];
                codes = [
                    'HAPPY',
                    'SAD',
                    'CALM',
                    'MAD',
                    'CONFIDENT',
                    'NERVOUS'
                ];
                setPractice(
                    <Record
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      instructions={instructions[topicPlay]}
                      names={names[topicPlay]}
                      texts={texts[topicPlay]}
                      voices={voices[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                      practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL1"}
                      conversation={'LISTENING'}
                      title={"Active Listening"}
                      subTitle={topicNames[topicPlay]}
                      topic={codes[topicPlay]}
                    />
                  );
                setTopicName(`LISTENING_${codes[topicPlay]}`)
                break;
            case 3:
                stepPrompts = [
                    'Step 1: Be Kind',
                    'Step 2: Ask Questions',
                    null,
                    null,
                ]
                const bullyingNames = [
                    'level1_friends_subject_bullying.mp4',
                    'level1_friends_outside_bullying.mp4',
                    'level1_friends_animal_bullying.mp4',
                    'level1_friends_food_bullying.mp4',
                    'level1_friends_fun_bullying.mp4',
                ]
                names = [
                    [
                        `level1_friends_subject_greet.mp4`,
                        `level1_friends_subject_ask.mp4`,
                        `level1_friends_subject_response.mp4`,
                        `level1_friends_subject_answer.mp4`,
                    ],
                    [
                        `level1_friends_outside_greet.mp4`,
                        `level1_friends_outside_ask.mp4`,
                        `level1_friends_outside_response.mp4`,
                        `level1_friends_outside_answer.mp4`,
                    ],
                    [
                        `level1_friends_animal_greet.mp4`,
                        `level1_friends_animal_ask.mp4`,
                        `level1_friends_animal_response.mp4`,
                        `level1_friends_animal_answer.mp4`,
                    ],
                    [
                        `level1_friends_food_greet.mp4`,
                        `level1_friends_food_ask.mp4`,
                        `level1_friends_food_response.mp4`,
                        `level1_friends_food_answer.mp4`,
                    ],
                    [
                        `level1_friends_fun_greet.mp4`,
                        `level1_friends_fun_ask.mp4`,
                        `level1_friends_fun_response.mp4`,
                        `level1_friends_fun_answer.mp4`,
                    ],
                ];
                instructions = [
                    [
                        'appfiles/friends_bullying/practice_playground_intro.mp4',
                        'appfiles/friends_bullying/practice_playground_greet.mp4',
                        'appfiles/friends_bullying/practice_playground_answer.mp4',
                        'appfiles/friends_bullying/practice_playground_ask.mp4',
                        'appfiles/friends_bullying/practice_playground_respond.mp4',
                    ],
                    [
                        'appfiles/friends_bullying/practice_baseball_intro.mp4',
                        'appfiles/friends_bullying/practice_baseball_greet.mp4',
                        'appfiles/friends_bullying/practice_baseball_answer.mp4',
                        'appfiles/friends_bullying/practice_baseball_ask.mp4',
                        'appfiles/friends_bullying/practice_baseball_respond.mp4',
                    ],
                    [
                        'appfiles/friends_bullying/practice_pond_intro.mp4',
                        'appfiles/friends_bullying/practice_pond_greet.mp4',
                        'appfiles/friends_bullying/practice_pond_answer.mp4',
                        'appfiles/friends_bullying/practice_pond_ask.mp4',
                        'appfiles/friends_bullying/practice_pond_respond.mp4',
                    ],
                    [
                        'appfiles/friends_bullying/practice_snack_intro.mp4',
                        'appfiles/friends_bullying/practice_snack_greet.mp4',
                        'appfiles/friends_bullying/practice_snack_answer.mp4',
                        'appfiles/friends_bullying/practice_snack_ask.mp4',
                        'appfiles/friends_bullying/practice_snack_respond.mp4',
                    ],
                    [
                        'appfiles/friends_bullying/practice_skateboard_intro.mp4',
                        'appfiles/friends_bullying/practice_skateboard_greet.mp4',
                        'appfiles/friends_bullying/practice_skateboard_answer.mp4',
                        'appfiles/friends_bullying/practice_skateboard_ask.mp4',
                        'appfiles/friends_bullying/practice_skateboard_respond.mp4',
                    ],
                ];
                texts = [
                    [
                        `Press record and say, "Hi! What is your name?"`,
                        `Press record and say, "What is your favorite subject at school?"`,
                        `Press record and say, "That is a great subject!"`,
                        `Press record and say your favorite subject in school.`,
                    ],
                    [
                        `Press record and say, "Hi! What is your name?"`,
                        `Press record and say, "What is your favorite thing to do outside?"`,
                        `Press record and say, "That is awesome!"`,
                        `Press record and say your favorite thing to do outside.`,
                    ],
                    [
                        `Press record and say, "Hi! What is your name?"`,
                        `Press record and say, "What animal do you like?"`,
                        `Press record and say, "Cool!"`,
                        `Press record and say what animal you like.`,
                    ],
                    [
                        `Press record and say, "Hi! What is your name?"`,
                        `Press record and say, "What is your favorite food?"`,
                        `Press record and say, "That is a good choice!"`,
                        `Press record and say your favorite food.`,
                    ],
                    [
                        `Press record and say, "Hi! What is your name?"`,
                        `Press record and say, "What do you like to do?"`,
                        `Press record and say, "Fun!"`,
                        `Press record and say what you like to do.`,
                    ],
                ];
                voices = [
                    [
                        'appfiles/friends_bullying/practice_playground_greet.mp3',
                        'appfiles/friends_bullying/practice_playground_ask.mp3',
                        'appfiles/friends_bullying/practice_playground_respond.mp3',
                        'appfiles/friends_bullying/practice_playground_answer.mp3',
                    ],
                    [
                        'appfiles/friends_bullying/practice_playground_greet.mp3',
                        'appfiles/friends_bullying/practice_baseball_ask.mp3',
                        'appfiles/friends_bullying/practice_baseball_respond.mp3',
                        'appfiles/friends_bullying/practice_baseball_answer.mp3',
                    ],
                    [
                        'appfiles/friends_bullying/practice_playground_greet.mp3',
                        'appfiles/friends_bullying/practice_pond_ask.mp3',
                        'appfiles/friends_bullying/practice_pond_respond.mp3',
                        'appfiles/friends_bullying/practice_pond_answer.mp3',
                    ],
                    [
                        'appfiles/friends_bullying/practice_playground_greet.mp3',
                        'appfiles/friends_bullying/practice_snack_ask.mp3',
                        'appfiles/friends_bullying/practice_snack_respond.mp3',
                        'appfiles/friends_bullying/practice_snack_answer.mp3',
                    ],
                    [
                        'appfiles/friends_bullying/practice_playground_greet.mp3',
                        'appfiles/friends_bullying/practice_skateboard_ask.mp3',
                        'appfiles/friends_bullying/practice_skateboard_respond.mp3',
                        'appfiles/friends_bullying/practice_skateboard_answer.mp3',
                    ],
                ];
                exampleVideos = [
                    'e294350f0903d692904e2d120bd2/480.m3u8',
                    '20e09d03369321476cb731f8bc8e/360.m3u8',
                    'abb95df072889cc1482d42c212fa/480.m3u8',
                    '0a653ee421546c268cd682d894f9/480.m3u8',
                    'bc6f2aaa640b56c6ca88d64e2718/480.m3u8',
                ];
                topicNames = [
                    'Favorite Subject in School',
                    'Outside',
                    'Animal',
                    'Food',
                    'What you like to do for fun',
                ];
                codes = [
                    'SUBJECT',
                    'OUTSIDE',
                    'ANIMAL',
                    'FOOD',
                    'FUN',
                ];
                celebrateAudios = ['appfiles/friends_bullying/friends_bullying_celebrate_record_kind.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_questions.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_not_bully.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_stop_bullying.mp3',
                    'appfiles/friends_bullying/friends_bullying_celebrate_record_making_friends.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am amazing because I am kind!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I ask good questions!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I do not bully others!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I tell others to stop bullying!"`,
                    `Record yourself in an excited voice and say, "I am amazing because I am good at making friends!"`]
                setPractice(
                    <Record
                      setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                      background={backgrounds[bgIdx]}
                      instructions={instructions[topicPlay]}
                      names={names[topicPlay]}
                      texts={texts[topicPlay]}
                      voices={voices[topicPlay]}
                      influencerid={influencers[topicPlay]}
                      practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                      practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                      awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                      practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                      practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                      awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                      exampleVideo={exampleVideos[topicPlay]}
                      finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                      level={"LEVEL1"}
                      conversation={'FRIENDS'}
                      topic={codes[topicPlay]}
                      stepPrompts={stepPrompts}
                      title={"Making Friends"}
                      subTitle={topicNames[topicPlay]}
                      bullyingName={bullyingNames[topicPlay]}
                    />
                );
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                setTopicName(`FRIENDS_${codes[topicPlay]}`)
                break;
            case 4:
                names = [
                    [`level1_solution_sad_answer.mp4`],
                    [`level1_solution_mad_answer.mp4`],
                    [`level1_solution_nervous_answer.mp4`],  
                ];
                instructions = [
                    [
                        'appfiles/freeplay/solution/intro_sad.mp4',
                        'appfiles/freeplay/solution/acknowledge_sad.mp4',
                    ],
                    [
                        'appfiles/freeplay/solution/intro_mad.mp4',
                        'appfiles/freeplay/solution/acknowledge_mad.mp4',
                    ],
                    [
                        'appfiles/freeplay/solution/intro_nervous.mp4',
                        'appfiles/freeplay/solution/acknowledge_nervous.mp4',
                    ],
                ];
                texts = [
                    [
                        'Press record and say, "I will choose to be happy and do something else."',
                    ],
                    [
                        'Press record and say, "I can take deep breaths and think positive thoughts."',
                    ],
                    [
                        'Press record and say, "I can sing the joyful jingle."',
                    ],
                ];
                voices = [
                    [
                        'appfiles/freeplay/solution/practice_record_prompt_sad.m4a'
                    ],
                    [
                        'appfiles/freeplay/solution/practice_record_prompt_mad.m4a'
                    ],
                    [
                        'appfiles/freeplay/solution/practice_record_prompt_nervous.m4a'
                    ]
                ]
                exampleVideos = [
                    'appfiles/freeplay/solution/demo_sad.mp4',
                    'appfiles/freeplay/solution/demo_mad.mp4',
                    'appfiles/freeplay/solution/demo_nervous.mp4',
                ];
                topicNames = [
                    'Sad',
                    'Mad',
                    'Nervous',
                ];
                codes = [
                    'SAD',
                    'MAD',
                    'NERVOUS'
                ];
                setPractice(
                    <Record
                    setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                    background={backgrounds[bgIdx]}
                    instructions={instructions[topicPlay]}
                    names={names[topicPlay]}
                    texts={texts[topicPlay]}
                    voices={voices[topicPlay]}
                    influencerid={influencers[topicPlay]}
                    exampleVideo={getVideo(exampleVideos[topicPlay], login)}
                    practiceConversation={getVideo('appfiles/greet/practice_watch_conversation.gif', login)}
                    practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                    awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                    practiceConversationAudio={'appfiles/greet/greet_practice_watch_conversation.mp3'}
                    practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                    awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                    finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                    level={"LEVEL1"}
                    conversation={'SOLUTION'}
                    topic={codes[topicPlay]}
                    title={"Solutions"}
                    subTitle={topicNames[topicPlay]}
                    />
                );
                setTopicName(`SOLUTION_${codes[topicPlay]}`)
                break;    
            case 5:
                stepPrompts = [
                    [
                        'Step 1: Be Calm',
                        'Step 2: Talk about it'
                    ],
                    'Step 3: Make it Better',
                    null,
                ]
                names = [
                    [
                      'level1_conflict_seat_1.mp4',
                      'level1_conflict_seat_2.mp4',
                      'level1_conflict_seat_3.mp4',
                    ],
                    [
                      'level1_conflict_shop_1.mp4',
                      'level1_conflict_shop_2.mp4',
                      'level1_conflict_shop_3.mp4',
                    ],
                    [
                      'level1_conflict_shovel_1.mp4',
                      'level1_conflict_shovel_2.mp4',
                      'level1_conflict_shovel_3.mp4',
                    ],
                    [
                      'level1_conflict_stand_1.mp4',
                      'level1_conflict_stand_2.mp4',
                      'level1_conflict_stand_3.mp4',
                    ],
                    [
                     'level1_conflict_photo_1.mp4',
                     'level1_conflict_photo_2.mp4',
                     'level1_conflict_photo_3.mp4',
                    ],
                ];

                instructions = [
                    [
                      'appfiles/resolve_conflict/practice_bus_1.mp4',
                      'appfiles/resolve_conflict/practice_bus_2.mp4',
                      'appfiles/resolve_conflict/practice_bus_3.mp4',
                    ],
                    [
                      'appfiles/resolve_conflict/practice_gift_1.mp4',
                      'appfiles/resolve_conflict/practice_gift_2.mp4',
                      'appfiles/resolve_conflict/practice_gift_3.mp4',
                      'appfiles/resolve_conflict/practice_gift_4.mp4',
                    ], 
                    [
                      'appfiles/resolve_conflict/practice_dig_1.mp4',
                      'appfiles/resolve_conflict/practice_dig_2.mp4',
                      'appfiles/resolve_conflict/practice_dig_3.mp4',
                    ],
                    [
                      'appfiles/resolve_conflict/practice_dino_1.mp4',
                      'appfiles/resolve_conflict/practice_dino_2.mp4',
                      'appfiles/resolve_conflict/practice_dino_3.mp4',
                      'appfiles/resolve_conflict/practice_dino_4.mp4',
                    ],
                    [
                      'appfiles/resolve_conflict/practice_herb_1.mp4',
                      'appfiles/resolve_conflict/practice_herb_2.mp4',
                      'appfiles/resolve_conflict/practice_herb_3.mp4',
                      'appfiles/resolve_conflict/practice_herb_4.mp4',
                    ],
                ];

                texts = [
                    [
                        `Press record and say, "I am sad because I want to sit where you are sitting."`,
                        `Press record and say, "I am sorry, I should not tell you to move."`,
                        `Press record and say, "Thanks, and let's sit by each other on the way home too!"`,
                    ],
                    [
                        `Press record and say, "I feel sad you do not like my toy. Can you tell me why?"`,
                        `Press record and say, "Thanks! It is okay to like different things."`,
                        `Press record and say, "Do you want to play with my toy?"`,
                    ],
                    [
                        `Press record and say, "Hi, what is wrong?"`,
                        `Press record and say, "I am sorry I took your shovel. I did not know you were using it."`,
                        `Press record and say, "Yes, and next time I will ask before taking a shovel."`,
                    ], 
                    [
                        `Press record and say, "I am sorry, I did not see you standing there."`,
                        `Press record and say, "I can move over so you can see the dinosaur too!"`,
                        `Press record and say, "I will make sure to watch where I am standing next time."`,
                    ],
                    [
                        `Press record and say, "Please be more careful, I am trying to take a picture."`,
                        `Press record and say, "It is okay."`,
                        `Press record and say, "Thanks, do you want to take pictures with me?"`,
                    ],
                ];

                voices = [
                    [
                      'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_1.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_2.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_3.mp3',
                    ],
                    [
                      'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_1.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_2.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_3.mp3',
                    ],
                    [
                      'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_1.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_2.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_3.mp3',
                    ],
                    [
                      'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_1.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_2.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_3.mp3',
                    ],
                    [
                      'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_1.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_2.mp3',
                      'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_3.mp3',
                    ],
                ];

                exampleVideos = [
                    '404cb8c87ea68b34d68800759f38/480.m3u8',
                    'fdddc64c4ad070485f1c4acc2d2b/480.m3u8',
                    '1ff916c5d26e53fbe959c4cca11e/480.m3u8',
                    '18146ebf75b03a8d7c401bc13231/480.m3u8',
                    '04f9df0feca686e42f2da64e25ba/480.m3u8',
                ];

                topicNames = [
                    'Seat Taken',
                    'Dislike Toy',
                    'Stole Shovel',
                    'Blocking View',
                    'Bumped Into',
                ];
                
                codes = [
                    'SEAT',
                    'SHOP',
                    'SHOVEL',
                    'STAND',
                    'PHOTO',
                ];
                celebrateAudios = ['appfiles/resolve_conflict/resolve_conflict_celebrate_calm.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_feelings.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_listener.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_solve_problems.mp3',
                    'appfiles/resolve_conflict/resolve_conflict_celebrate_better.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am a very important person because I know when to be calm!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can talk about my feelings!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I am a good listener!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I solve problems with friends!"`,
                    `Record yourself in an excited voice and say, "I am a very important person because I can make things better!"`]
                setPractice(
                    <Record
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        instructions={instructions[topicPlay]}
                        names={names[topicPlay]}
                        texts={texts[topicPlay]}
                        voices={voices[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL1"}
                        conversation={'CONFLICT'}
                        topic={codes[topicPlay]}
                        stepPrompts={stepPrompts}
                        title={"Resolving Conflicts"}
                        subTitle={topicNames[topicPlay]}
                    />
                );
                setTopicName(`CONFLICT_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 6:
                stepPrompts = [
                    [
                        'Step 1: Think\nThink about what you want to say',
                        'Step 2: Believe\nBelieve in yourself',
                        'Step 3: Achieve\nAchieve it!',
                    ]
                ]
                names = [
                    [
                      'level1_advocacy_bird_greet.mp4',
                      'level1_advocacy_bird_close.mp4',
                    ],
                    [
                      'level1_advocacy_train_greet.mp4',
                      'level1_advocacy_train_close.mp4',
                    ],
                    [
                      'level1_advocacy_monkey_greet.mp4',
                      'level1_advocacy_monkey_close.mp4',
                    ],
                    [
                      'level1_advocacy_care_greet.mp4',
                      'level1_advocacy_care_close.mp4',
                    ],
                    [
                      'level1_advocacy_snack_greet.mp4',
                      'level1_advocacy_snack_close.mp4',
                    ],
                  ];

                instructions = [
                    [
                      'appfiles/self_advocacy/practice_birdshow_greet.mp4',
                      'appfiles/self_advocacy/practice_birdshow_answer.mp4',
                      'appfiles/self_advocacy/practice_birdshow_close.mp4',
                    ],
                    [
                      'appfiles/self_advocacy/practice_train_greet.mp4',
                      'appfiles/self_advocacy/practice_train_answer.mp4',
                      'appfiles/self_advocacy/practice_train_close.mp4',
                    ],
                    [
                      'appfiles/self_advocacy/practice_monkey_greet.mp4',
                      'appfiles/self_advocacy/practice_monkey_answer.mp4',
                      'appfiles/self_advocacy/practice_monkey_close.mp4',
                    ],
                    [
                      'appfiles/self_advocacy/practice_reptiles_greet.mp4',
                      'appfiles/self_advocacy/practice_reptiles_answer.mp4',
                      'appfiles/self_advocacy/practice_reptiles_close.mp4',
                    ],
                    [
                      'appfiles/self_advocacy/practice_snacks_greet.mp4',
                      'appfiles/self_advocacy/practice_snacks_answer.mp4',
                      'appfiles/self_advocacy/practice_snacks_close.mp4',
                    ]
                  ];

                texts = [
                    [
                      `Press record and say, "It is good to meet you. Can I feed the birds, please?"`,
                      `Press record and say, "You are welcome. Bye!"`,
                    ],
                    [
                      `Press record and say, "Hi! Can you please tell me where I can buy a train ticket?"`,
                      `Press record and say, "Thanks, and have a good day!"`,
                    ],
                    [
                      `Press record and say, "Hello! What do monkeys like to eat?"`,
                      `Press record and say, "Thanks!"`,
                    ],
                    [
                      `Press record and say, "Hi! Can you help me find my teacher?"`,
                      `Press record and say, "Thank you so much!"`,
                    ],
                    [
                      `Press record and say, "Hi! Can I get a napkin, please?"`,
                      `Press record and say, "Thank you so much. Bye!"`,
                    ],
                ];

                voices = [
                    [
                      'appfiles/self_advocacy/practice_birdshow_greet_prompt.m4a',
                      'appfiles/self_advocacy/practice_birdshow_close_prompt.mp3',
                    ],
                    [
                      'appfiles/self_advocacy/practice_train_greet_prompt.mp3',
                      'appfiles/self_advocacy/practice_train_close_prompt.mp3',
                    ],
                    [
                      'appfiles/self_advocacy/practice_monkey_greet_prompt.mp3',
                      'appfiles/self_advocacy/practice_monkey_close_prompt.mp3',
                    ],
                    [
                      'appfiles/self_advocacy/practice_reptile_greet_prompt.mp3',
                      'appfiles/self_advocacy/practice_reptile_close_prompt.mp3',
                    ],
                    [
                      'appfiles/self_advocacy/practice_snack_greet_prompt.mp3',
                      'appfiles/self_advocacy/practice_snack_close_prompt.mp3',
                    ]
                ];

                exampleVideos = [
                    'f06b82cae82f3db9ed5f8f897105/480.m3u8',
                    '9550b4175a782c9389044a6ec646/360.m3u8',
                    'c5d12c682e57d21a4af35c6b9f72/480.m3u8',
                    'ca7ad958f25622f7befcd5a1cc35/360.m3u8',
                    '73a5fde4b0fe966c33648df9d5f2/480.m3u8',
                ];

                topicNames = [
                    'Feed the Birds',
                    'Buy a Ticket',
                    'Monkey’s Food',
                    'Ask for Teacher',
                    'Ask for Napkin',
                ];

                codes = [
                    'BIRD',
                    'TRAIN',
                    'MONKEY',
                    'CARE',
                    'SNACK',
                ];

                celebrateAudios = ['appfiles/self_advocacy/self_advocacy_celebrate_record_think.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_believe.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_achieve.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_speak_up.mp3',
                    'appfiles/self_advocacy/self_advocacy_celebrate_record_stand_up.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I can do it all, because I think about what I want to say or do!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I believe in myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I achieve great things!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can speak up for myself!"`,
                    `Record yourself in an excited voice and say, "I can do it all, because I can stand up for myself!"`]
                setPractice(
                    <Record
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        instructions={instructions[topicPlay]}
                        names={names[topicPlay]}
                        texts={texts[topicPlay]}
                        voices={voices[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL1"}
                        conversation={'ADVOCACY'}
                        topic={codes[topicPlay]}
                        stepPrompts={stepPrompts}
                        title={"Self-Advocacy"}
                        subTitle={topicNames[topicPlay]}
                    />
                );
                setTopicName(`ADVOCACY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            case 7:
                //bold the step numbers
                stepPrompts = [
                    [['<b>Step 1: How I act!</b>\nRemember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', '<b>Step 2: What I Say!</b>\nUse kind words', '<b>Step 3: How I Say It!</b>\nTalk to the community worker in a calm voice']],
                    [['<b>Step 1: How I act!</b>\nRemember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', '<b>Step 2: What I Say!</b>\nUse kind words', '<b>Step 3: How I Say It!</b>\nTalk to the community worker in a calm voice']],
                    [['<b>Step 1: How I act!</b>\nRemember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', '<b>Step 2: What I Say!</b>\nUse kind words', '<b>Step 3: How I Say It!</b>\nTalk to the community worker in a calm voice']],
                    [['<b>Step 1: How I act!</b>\nRemember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', '<b>Step 2: What I Say!</b>\nUse kind words', '<b>Step 3: How I Say It!</b>\nTalk to the community worker in a calm voice']],
                    [['<b>Step 1: How I act!</b>\nRemember to look at their eyes, listen, smile, keep your body tall and stand at arm’s length.', '<b>Step 2: What I Say!</b>\nUse kind words', '<b>Step 3: How I Say It!</b>\nTalk to the community worker in a calm voice']],
                    [['Step 1: See It (you want to buy gum)', 'Step 2: Fix It (you buy the gum)'], null, null, ['Step 3: Make It Better (kindly respond to the worker)']],
                    [['Step 1: See It (you see you need a haircut)', 'Step 2: Fix It (you get a hair cut)', 'Step 3: Make It Better (you give the hairdresser a compliment)']],
                    [[`Step 1: See It (you can't find the socks at the store)`, 'Step 2: Fix It (you ask the worker for help)'], null, null, ['Step 3: Make It Better (kindly respond to the worker)']],
                    [['Step 1: See It (you want to talk to the baker about cupcakes)', 'Step 2: Fix It (you talk to the baker)'], null, null, ['Step 3: Make It Better (kindly respond to the baker)']],
                    [['Step 1: See It (you want to watch a movie)', 'Step 2: Fix It (you go to the movie theater)'], null, null, ['Step 3: Make It Better (kindly respond to the worker)']],
                ]
                instructions = [
                    [
                        'appfiles/manners/practice_snowcone_greeting.mp4',
                        'appfiles/manners/practice_snowcone_ask.mp4',
                        'appfiles/manners/practice_snowcone_respond.mp4',
                        'appfiles/manners/practice_snowcone_close.mp4',
                    ],
                    [
                        'appfiles/manners/practice_beach_greeting.mp4',
                        'appfiles/manners/practice_beach_ask.mp4',
                        'appfiles/manners/practice_beach_respond.mp4',
                        'appfiles/manners/practice_beach_close.mp4',
                    ],
                    [
                        'appfiles/manners/practice_ferris_wheel_greeting.mp4',
                        'appfiles/manners/practice_ferris_wheel_ask.mp4',
                        'appfiles/manners/practice_ferris_wheel_respond.mp4',
                        'appfiles/manners/practice_ferris_wheel_close.mp4',
                    ],
                    [
                        'appfiles/manners/practice_arcade_greeting.mp4',
                        'appfiles/manners/practice_arcade_ask.mp4',
                        'appfiles/manners/practice_arcade_respond.mp4',
                        'appfiles/manners/practice_arcade_close.mp4',
                    ],
                    [
                        'appfiles/manners/practice_food_greeting.mp4',
                        'appfiles/manners/practice_food_ask.mp4',
                        'appfiles/manners/practice_food_respond.mp4',
                        'appfiles/manners/practice_food_close.mp4',
                    ],
                    [
                        'appfiles/caring/practice_grocery_1.mp4',
                        'appfiles/caring/practice_grocery_2.mp4',
                        'appfiles/caring/practice_grocery_3.mp4',
                        'appfiles/caring/practice_grocery_4.mp4',
                        'appfiles/caring/practice_grocery_5.mp4',
                    ],
                    [
                        'appfiles/caring/practice_hair_1.mp4',
                        'appfiles/caring/practice_hair_2.mp4',
                        'appfiles/caring/practice_hair_3.mp4',
                        'appfiles/caring/practice_hair_4.mp4',
                    ],
                    [
                        'appfiles/caring/practice_clothing_1.mp4',
                        'appfiles/caring/practice_clothing_2.mp4',
                        'appfiles/caring/practice_clothing_3.mp4',
                        'appfiles/caring/practice_clothing_4.mp4',
                    ],
                    [
                        'appfiles/caring/practice_baker_1.mp4',
                        'appfiles/caring/practice_baker_2.mp4',
                        'appfiles/caring/practice_baker_3.mp4',
                        'appfiles/caring/practice_baker_4.mp4',
                    ],
                    [
                        'appfiles/caring/practice_movie_1.mp4',
                        'appfiles/caring/practice_movie_2.mp4',
                        'appfiles/caring/practice_movie_3.mp4',
                        'appfiles/caring/practice_movie_4.mp4',
                    ]
                ];
                names = [
                    [
                        'level1_community_cone_greet.mp4',
                        'level1_community_cone_ask.mp4',
                        'level1_community_cone_close.mp4',
                    ],
                    [
                        'level1_community_guard_greet.mp4',
                        'level1_community_guard_ask.mp4',
                        'level1_community_guard_close.mp4',
                    ],
                    [
                        'level1_community_wheel_greet.mp4',
                        'level1_community_wheel_ask.mp4',
                        'level1_community_wheel_close.mp4',
                    ],
                    [
                        'level1_community_arcade_greet.mp4',
                        'level1_community_arcade_ask.mp4',
                        'level1_community_arcade_close.mp4',
                    ],
                    [
                        'level1_community_food_greet.mp4',
                        'level1_community_food_ask.mp4',
                        'level1_community_food_close.mp4',
                    ],
                    [
                        'level1_community_grocery_1.mp4',
                        'level1_community_grocery_2.mp4',
                        'level1_community_grocery_3.mp4',
                        'level1_community_grocery_4.mp4',
                    ],
                    [
                        'level1_community_salon_1.mp4',
                        'level1_community_salon_2.mp4',
                        'level1_community_salon_3.mp4',
                        'level1_community_salon_4.mp4',
                    ],
                    [
                        'level1_community_clothing_1.mp4',
                        'level1_community_clothing_2.mp4',
                        'level1_community_clothing_3.mp4',
                        'level1_community_clothing_4.mp4',
                    ],
                    [
                        'level1_community_bakery_1.mp4',
                        'level1_community_bakery_2.mp4',
                        'level1_community_bakery_3.mp4',
                        'level1_community_bakery_4.mp4',
                    ],
                    [
                        'level1_community_theater_1.mp4',
                        'level1_community_theater_2.mp4',
                        'level1_community_theater_3.mp4',
                        'level1_community_theater_4.mp4',
                    ],
                ];
                texts = [
                    [
                        `Press record and say, "Hello!"`,
                        `Press record and say your favorite flavor.`,
                        `Press record and say, "Goodbye!"`,
                    ],
                    [
                        `Press record and say, "Hi!"`,
                        `Press record and say your favorite thing to do at the beach.`,
                        `Press record and say, "Goodbye!"`,
                    ],
                    [
                        `Press record and say, "It is good to meet you!"`,
                        `Press record and say if you want the ferris wheel to go fast or slow.`,
                        `Press record and say, "See you later!"`,
                    ],
                    [
                        `Press record and say, "Good afternoon!"`,
                        `Press record and say your favorite game.`,
                        `Press record and say, "Bye!"`,
                    ],
                    [
                        `Press record and say, "It is good to meet you!"`,
                        `Press record and say what you would like to eat.`,
                        `Press record and say, "See ya!"`,
                    ],
                    [
                        `Press record and say, "I am good, thanks."`,
                        `Press record and say, "A pack of gum, please."`,
                        `Press record and say, "Here you go."`,
                        `Press record and say, "You're welcome. See you later!"`,
                    ],
                    [
                        `Press record and say, "Hello!"`,
                        `Press record and say, "You do a great job!"`,
                        `Press record and say, "You're welcome."`,
                        `Press record and say, "Goodbye."`,
                    ],
                    [
                        `Press record and say, "It is nice to meet you!"`,
                        `Press record and say, "Can you help me find the socks, please?"`,
                        `Press record and say, "Thank you very much!"`,
                        `Press record and say, "Bye!"`,
                    ],
                    [
                        `Press record and say, "Hello!"`,
                        `Press record and say your favorite flavor.`,
                        `Press record and say, "Awesome!"`,
                        `Press record and say, "Goodbye!"`,
                    ],
                    [
                        `Press record and say, "I am good! Thank you!"`,
                        `Press record and say, "Here you go."`,
                        `Press record and say, "That's great! Thanks!"`,
                        `Press record and say, "See ya!"`,
                    ],
                ];
                voices = [
                    [
                        'appfiles/manners/practice_snowcone_greeting_prompt.mp3',
                        'appfiles/manners/practice_snowcone_ask_prompt.mp3',
                        'appfiles/manners/practice_snowcone_close_prompt.mp3',
                    ],
                    [
                        'appfiles/manners/practice_beach_greeting_prompt.mp3',
                        'appfiles/manners/practice_beach_ask_prompt.mp3',
                        'appfiles/manners/practice_snowcone_close_prompt.mp3',,
                    ],
                    [
                        'appfiles/manners/practice_ferris_wheel_greeting_prompt.mp3',
                        'appfiles/manners/practice_ferris_wheel_ask_prompt.mp3',
                        'appfiles/manners/practice_ferris_wheel_close_prompt.mp3',,
                    ],
                    [
                        'appfiles/manners/practice_arcade_greeting_prompt.mp3',
                        'appfiles/manners/practice_arcade_ask_prompt.mp3',
                        'appfiles/manners/practice_arcade_close_prompt.mp3',,
                    ],
                    [
                        'appfiles/manners/practice_ferris_wheel_greeting_prompt.mp3',
                        'appfiles/manners/practice_food_ask_prompt.mp3',
                        'appfiles/manners/practice_food_close_prompt.mp3',,
                    ],
                    [
                        'appfiles/caring/practice_record_grocery_1.mp3',
                        'appfiles/caring/practice_record_grocery_2.mp3',
                        'appfiles/caring/practice_record_grocery_3.mp3',
                        'appfiles/caring/practice_record_grocery_4.mp3',
                    ],
                    [
                        'appfiles/caring/practice_record_baker_1.mp3',
                        'appfiles/caring/practice_record_hair_1.mp3',
                        'appfiles/caring/practice_record_hair_2.mp3',
                        'appfiles/caring/practice_record_hair_3.mp3',
                    ],
                    [
                        'appfiles/caring/practice_record_clothing_1.mp3',
                        'appfiles/caring/practice_record_clothing_2.mp3',
                        'appfiles/caring/practice_record_clothing_3.mp3',
                        'appfiles/caring/practice_record_clothing_4.mp3',
                    ],
                    [
                        'appfiles/caring/practice_record_baker_1.mp3',
                        'appfiles/caring/practice_record_baker_2.mp3',
                        'appfiles/caring/practice_record_baker_3.m4a',
                        'appfiles/caring/practice_record_baker_4.m4a',
                    ],
                    [
                        'appfiles/caring/practice_record_movie_1.mp3',
                        'appfiles/caring/practice_record_movie_2.mp3',
                        'appfiles/caring/practice_record_movie_3.mp3',
                        'appfiles/caring/practice_record_movie_4.mp3',
                    ]
                ];
                exampleVideos = [
                    '3fdbbcc43c87c92ae2d9a8b58e1a/480.m3u8',
                    'a206033e9e68ceebfd64f6f631a3/480.m3u8',
                    'a5c56f28753f1a2e91c91a373e94/480.m3u8',
                    '7a77d2fbfa33ac22810725c228a4/480.m3u8',
                    'b06fdefc2247638b56e9bf9cde38/480.m3u8',
                    '4b742312947d83473d21f6888019/480.m3u8',
                    'f8e52e21ea4561a78d5c38967804/480.m3u8',
                    'debc60bcaf698b2ac158fd60ca8b/480.m3u8',
                    'Module20/day4_practice_conversation.mp4',
                    'Module20/day8_practice_conversation.mp4',
                ];

                codes = [
                    'CONE',
                    'GUARD',
                    'WHEEL',
                    'ARCADE',
                    'FOOD',
                    'GROCERY',
                    'SALON',
                    'CLOTHING',
                    'BAKERY',
                    'THEATER'
                ];

                topicNames = [
                    'Snow Cone Stand',
                    'Beach',
                    'Theme Park',
                    'Arcade',
                    'Fast Food',
                    'Grocery Store',
                    'Salon',
                    'Clothing Store',
                    'Bakery',
                    'Movie Theater',
                ]

                celebrateAudios = ['appfiles/manners/manners_celebrate_please.mp3',
                    'appfiles/manners/manners_celebrate_thank.mp3',
                    'appfiles/manners/manners_celebrate_calm.mp3',
                    'appfiles/manners/manners_celebrate_smile.mp3',
                    'appfiles/manners/manners_celebrate_body_tall.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_myself.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_others.mp3',
                    'appfiles/caring/caring_celebrate_record_take_care_world.mp3',
                    'appfiles/caring/caring_celebrate_record_see_fix.mp3',
                    'appfiles/caring/caring_celebrate_record_hard_things.mp3']
                celebrateTexts = [`Record yourself in an excited voice and say, "I am awesome because I say please!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I say thank you!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I talk in a calm voice."`,
                    `Record yourself in an excited voice and say, "I am awesome because I smile!"`,
                    `Record yourself in an excited voice and say, "I am awesome because I keep my body tall!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of myself!"`,
                    `Record yourself in an excited voice and say, "I believe in me because I take care of others!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I take care of the world!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can see it, fix it and make it even better!"`,
                    `Record yourself in an excited voice and say, "I believe in me, because I can do hard things!"`]
                setPractice(
                    <Record
                        setDisplayPractice={()=>{setDisplayStep2(true); setDisplayStep3(false)}}
                        background={backgrounds[bgIdx]}
                        instructions={instructions[topicPlay]}
                        names={names[topicPlay]}
                        texts={texts[topicPlay]}
                        voices={voices[topicPlay]}
                        influencerid={influencers[topicPlay]}
                        practiceConversation={getVideo('appfiles/manners/manners_let_watch.gif', login)}
                        practiceMessage={getVideo('appfiles/greet/greet_special_message.gif', login)}
                        awesomeJob={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
                        practiceConversationAudio={'appfiles/freeplay/practice_watch_conversation.mp3'}
                        practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
                        awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
                        exampleVideo={exampleVideos[topicPlay]}
                        finish={()=>{setDisplayStep3(false); setDisplayCoin(true)}}
                        level={"LEVEL1"}
                        conversation={'COMMUNITY'}
                        topic={codes[topicPlay]}
                        stepPrompts={stepPrompts[topicPlay]}
                        title={'Community Locations'}
                        subTitle={topicNames[topicPlay]}
                        care={topicPlay < 5 ? false : true}
                    />
                );
                setTopicName(`COMMUNITY_${codes[topicPlay]}`)
                setCelebrateVoice(getVideo(celebrateAudios[topicPlay], login))
                setCelebrateText(celebrateTexts[topicPlay])
                break;
            default:
                break;
        }
        setDisplaySurpriseVideoIcon(false);
        setDisplayStep3(true)
        // setDisplayGame(true)
    }

    const onStop = (bought, data) => {
        const position = { x: data.x / clientWidth, y: data.y / clientHeight };
        freeplay.level1Decorate.items = freeplay.level1Decorate.items.map(item => 
            item === bought? {...item, position} : item
        );
        setBoughts(freeplay.level1Decorate.items)
    };

    const goBack = () => {
        if(displayStep2){
            setDisplayStep1(true);  
            setDisplayStep2(false);
            setDisplaySurpriseVideoIcon(false);
        }
        else if(displayStep3){
            setDisplayStep2(true); 
            setDisplayStep3(false)
        }
        else{
            navigate("/freeplay")
        }
    };

    const checkCompletion = async () => {
        switch (conversationNum) {
            case 0:
                if (Object.values(freeplay.level1.favorite).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_favorite_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/crab_mask.png')} animalName={'crab'} level={'level1'} topic={'favorite'} width={100} height={170} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 1:
                if (Object.values(freeplay.level1.feeling).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_feeling_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/dog_mask.png')} animalName={'dog'} level={'level1'} topic={'feeling'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 2:
                if (Object.values(freeplay.level1.listening).filter(value => value.unlocked === 1).length === 6) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_listening_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/lizzard_mask.png')} animalName={'lizzard'} level={'level1'} topic={'listening'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 3:
                if (Object.values(freeplay.level1.friends).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_friends_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/monkey_mask.png')} animalName={'monkey'} level={'level1'} topic={'friends'} width={100} height={170} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 4:
                if (Object.values(freeplay.level1.solution).filter(value => value.unlocked === 1).length === 3) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_solution_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/bird_mask.png')} animalName={'bird'} level={'level1'} topic={'solution'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 5:
                if (Object.values(freeplay.level1.conflict).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_conflict_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/lion_mask.png')} animalName={'lion'} level={'level1'} topic={'conflict'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 6:
                if (Object.values(freeplay.level1.advocacy).filter(value => value.unlocked === 1).length === 5) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_advocacy_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/elephant_mask.png')} animalName={'elephant'} level={'level1'} topic={'advocacy'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            case 7:
                if (Object.values(freeplay.level1.community).filter(value => value.unlocked === 1).length === 10) {
                    const data = await GetUserVideo(`userfiles/${login.studentid}/level1_community_animal.png`);
                    const response = await fetch(data);
                    if (response.status !== 200) {
                        setAnimal(<Animal animal={generateImageUrl('images/newDesign/FreePlay/masks/toucan_mask.png')} animalName={'toucan'} level={'level1'} topic={'community'} width={90} height={160} setDisplayAnimal={setDisplayAnimal} setPrize={setPrize} />);
                        setDisplayGame(false);
                        setDisplayAnimal(true);
                        rewardSound.play();
                    } else {
                        navigate("/freeplay");
                    }
                }
                else{
                    navigate("/freeplay");
                }
                break;
            default:
                break;
        }
    };
    

    const retakePhoto = (item) => {
        let height = 160;
        let width = 90;
        if(item.animal === 'crab' || item.animal === 'monkey'){
            height = 170
            width = 100
        }
        setAnimal(<Animal animal={generateImageUrl(`images/newDesign/FreePlay/masks/${item.animal}_mask.png`)} animalName={item.animal} level={'level1'} topic={item.name} width={width} height={height} setDisplayAnimal={setDisplayAnimal} getAnimals={getAnimals} finish={()=>{setDisplayStoreCharacter(true); setDisplayAnimal(false);}}/>)
        setDisplayStore(false);
        setDisplayStoreCharacter(false);
        setDisplayAnimal(true);
    }

    const getSurprise = async () => {
        let usePhoto = []
        switch(conversationNum){
            case 0:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_COLOR.mp4`,
                    },
                    {
                        video: `appfiles/close/close_greeting_5.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_favorite_color_greet.mp4`,
                    },
                    {
                        video: `appfiles/close/close_question_5.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_favorite_color_response.mp4`,
                    },
                    {
                        video: `appfiles/close/close_acknowledge_5.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_favorite_color_ask.mp4`,
                    },
                    {
                        video: `appfiles/close/close_response_5.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_favorite_color_acknowledge.mp4`,
                    },
                    {
                        video: `appfiles/close/close_close_5.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_favorite_color_close.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FAVORITE_ANIMAL.mp4`,
                    },
                ];
                break;
            case 1:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_CONFIDENT.mp4`,
                    },
                    {
                        video: `appfiles/freeplay/feeling/intro_confident.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_feeling_confident_answer.mp4`,
                    },
                    {
                        video: `appfiles/freeplay/feeling/response_confident.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_feeling_confident_acknowledge.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FEELING_HAPPY.mp4`,
                    },
                ];
                break;
            case 2:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_HAPPY.mp4`,
                    },
                    {
                        video: `appfiles/active_listening/practice_new_friend.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_listening_happy_acknowledge.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_LISTENING_CALM.mp4`,
                    },
                ];
                break;
            case 3:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_SUBJECT.mp4`,
                    },
                    {
                        video: `appfiles/friends_bullying/practice_playground_intro.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_friends_subject_greet.mp4`,
                    },
                    {
                        video: `appfiles/friends_bullying/practice_playground_greet.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_friends_subject_ask.mp4`,
                    },
                    {
                        video: `appfiles/friends_bullying/practice_playground_answer.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_friends_subject_response.mp4`,
                    },
                    {
                        video: `appfiles/friends_bullying/practice_playground_ask.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_friends_subject_answer.mp4`,
                    },
                    {
                        video: `appfiles/friends_bullying/practice_playground_respond.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_FRIENDS_OUTSIDE.mp4`,
                    },
                ];
                break;
            case 4:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_NERVOUS.mp4`,
                    },
                    {
                        video: `appfiles/freeplay/solution/intro_nervous.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_solution_nervous_answer.mp4`,
                    },
                    {
                        video: `appfiles/freeplay/solution/acknowledge_nervous.mp4`,
                    },
                    {
                        video: `influencers/${influencers[2]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_SOLUTION_SAD.mp4`,
                    },
                ];
                break;
            case 5:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_SHOP.mp4`,
                    },
                    {
                        video: `appfiles/resolve_conflict/practice_gift_1.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_conflict_shop_1.mp4`,
                    },
                    {
                        video: `appfiles/resolve_conflict/practice_gift_2.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_conflict_shop_2.mp4`,
                    },
                    {
                        video: `appfiles/resolve_conflict/practice_gift_3.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_conflict_shop_3.mp4`,
                    },
                    {
                        video: `influencers/${influencers[0]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_CONFLICT_PHOTO.mp4`,
                    },
                ];
                break;
            case 6:
                usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_TRAIN.mp4`,
                    },
                    {
                        video: `appfiles/self_advocacy/practice_reptiles_greet.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_advocacy_care_greet.mp4`,
                    },
                    {
                        video: `appfiles/self_advocacy/practice_care_answer.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_advocacy_reptiles_close.mp4`,
                    },
                    {
                        video: `influencers/${influencers[3]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_ADVOCACY_CARE.mp4`,
                    },
                ];
                break;
            case 7:
            usePhoto = [
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_FOOD.mp4`,
                    },
                    {
                        video: `appfiles/manners/practice_food_greeting.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_community_food_greet.mp4`,
                    },
                    {
                        video: `appfiles/manners/practice_food_ask.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_community_food_ask.mp4`,
                    },
                    {
                        video: `appfiles/manners/practice_food_respond.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_community_food_close.mp4`,
                    },
                    {
                        video: `appfiles/manners/practice_food_close.mp4`,
                    },
                    {
                        video: `influencers/${influencers[4]}/conversation_affirmation.mp4`,
                    },
                    {
                        video: `userfiles/${login.studentid}/level1_celebration_COMMUNITY_THEATER.mp4`,
                    },
                ];
                break;
            default:
                break;
        }

        for (let i = 0; i < usePhoto.length; i++) {
            await GetUserVideo(usePhoto[i].video, login).then((data) => {
            usePhoto[i].video = data;
            });
        }
        
        return usePhoto;
    };
    
    const playSurpriseVideo = async (intro = true) => {
        let music = ""
        switch(conversationNum){
            case 0:
                music = "appfiles/close/close_full_song_instrumental.m4a"
                break;
            case 1:
                music = "appfiles/feelings/feelings_instrumental.m4a"
                break;
            case 2:
                music = "appfiles/active_listening/active_listening_instrumental.m4a"
                break; 
            case 3:
                music = "appfiles/friends_bullying/friends_bullying_instrumental.m4a"
                break; 
            case 4:
                music = "appfiles/solutions/solutions_instrumental.m4a"
                break; 
            case 5:
                music = "appfiles/resolve_conflict/resolve_conflict_instrumental.m4a"
                break; 
            case 6:
                music = "appfiles/selfadvocacy/self_advocacy_instrumental.m4a"
                break; 
            case 7:
                music = "appfiles/manners/manners_instrumental.m4a"
                break; 
            default:
                break;
        }
        await getSurprise().then((photo) => {
            setSurpriseVideo(
            <Surprise
                background={backgrounds[bgIdx]}
                music={generateImageUrl('media/Freeplay/surprise_intrumental.mp3')}
                introVideo={intro ? 'd6c6b74e964a62fe8a9940bd860c/480.m3u8' : ""}
                back={'/'}
                slides={photo}
                setDisplaySurprise={setDisplaySurpriseVideo}
            />
            );
        });
        setDisplaySurpriseVideo(true);
    };

    return (
        <>
        {displaySurpriseVideo && surpriseVideo}
        {!displaySurpriseVideo && <div className='level1Body' style={{ backgroundImage: `url(${backgrounds[bgIdx]})`,  overflowY: "scroll"}}>
            {displayDecorate && !displayStore && !displayStoreCharacter && <div className='decorate' style={{zIndex : !change ? 1 : 0}}>
                    {/* <h2><a onClick={() => {navigate("/freeplay")}}>&#60; BACK</a></h2> */}
                    {/* <img className='bin' id='bin' src={Bin}/> */}
                    <img alt='store button' className='store' src={Store} onClick={() => {setDisplayStore(true); setDisplayAnimal(false)}}/>
                    <footer>
                        <h2><a onClick={displayAnimal ? () => {setDisplayAnimal(false); setDisplayStoreCharacter(true)} : () => {navigate("/freeplay")}}>&#60; BACK</a></h2>
                    </footer> 
            </div>}
            {(displayStep1 || displayStep2 || displayCoin || displayCelebrate || displayCoinAfterCelebrate) && <header>
                <div className='actions'>
                    {/* {(displayStep1 || displayStep2) && <h2><a onClick={goBack}>&#60; BACK</a></h2>} */}
                    {displaySurpriseVideoIcon && (
                        <img className='surprise' src={giftBtn} alt='Surprise Video' onClick={()=>{playSurpriseVideo(false)}} />
                    )}
                </div>
                <div className='coins'>
                    <img src={coin} alt='crab Icon'/>
                    {freeplay.level1Coin < 10 && <div className='coin1'>{freeplay.level1Coin}</div>}
                    {freeplay.level1Coin >= 10 && freeplay.level1Coin < 100 && <div className='coin10'>{freeplay.level1Coin}</div>}
                    {freeplay.level1Coin >= 100 && <div className='coin100'>{freeplay.level1Coin}</div>}
                </div>
            </header>}
            <footer>
                {(displayStep1 || displayStep2) && <h2><a onClick={goBack}>&#60; BACK</a></h2>}
            </footer> 
            {displayStore && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level1Coin} level={"LEVEL1"} decorate={freeplay.level1Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStore} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto}/>}
            {displayStoreCharacter && storeReady && <StorePage getAnimals={getAnimals} coin={freeplay.level1Coin} level={"LEVEL1"} decorate={freeplay.level1Decorate} bgs={backgrounds} setBgIdx={setBgIdx} buys={buys} boughts={boughts} setBoughts={setBoughts} close={setDisplayStoreCharacter} animals={animals} setUpdate={setUpdate} update={update} setChange={setChange} retakePhoto={retakePhoto} character={true}/>}
            {displayStep1 && <div className='conversation'>
                <h2 className='header'>
                    Choose Your Conversation
                </h2>
                <h3 className='text'>
                    Click the conversation you want to practice
                </h3>
                <Container>
                    <Row xs={2} md={3} lg={4}>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(0, 'Favorite Things')}} role='button'>
                                <div className='text'>Favorite Things</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.favorite).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.favorite).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.favorite).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.favorite).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(1, 'Talk about Feelings')}} role='button'>
                                <div className='text'>Talk about Feelings</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.feeling).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.feeling).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.feeling).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.feeling).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(2, 'Active Listening')}} role='button'>
                                <div className='text'>Active Listening</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.listening).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.listening).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.listening).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.listening).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(3, 'Making Friends')}} role='button'>
                                <div className='text'>Making Friends</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.friends).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.friends).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.friends).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.friends).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(4, 'Solutions')}}>
                                <div className='text'>Solutions</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.solution).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.solution).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.solution).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.solution).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(5, 'Resolve Conflict')}} role='button'>
                                <div className='text'>Resolve Conflict</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.conflict).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.conflict).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.conflict).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.conflict).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(6, 'Self-Advocacy')}}>
                                <div className='text'>Self-Advocacy</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.advocacy).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.advocacy).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.advocacy).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.advocacy).length} Completed</div>}
                            </div>
                        </Col>
                        <Col> 
                            <div className='option' onClick={() => {setConversation(7, 'Community Locations: Manners & Caring')}} role='button'>
                                <div className='text'>Community Locations</div>
                                <img alt='play icon' className='icon' src={playIcon} />
                                {(Object.values(freeplay.level1.community).filter(value => value.unlocked === 1).length === Object.keys(freeplay.level1.community).length) ? <div className='optionProgress'>Completed</div> : <div className='optionProgress'>{Object.values(freeplay.level1.community).filter(value => value.unlocked === 1).length} / {Object.keys(freeplay.level1.community).length} Completed</div>}
                            </div>
                        </Col>
    
                    </Row>
                </Container>
            </div>}
            {displayStep2 && <div className='topic'>
                <h2 className='header'>
                    {conversationName}
                </h2>
                <h3 className='text'>
                    Click the topic you want to practice
                </h3>
                <div className={`conversation_${conversationNum}`}>
                    <Container>
                        <Row xs={2} md={3} lg={4}>
                            {topics.map((topic, index) => (
                                <Col key={index}> 
                                    {conversationNum === 7 && (index < 5 ? <h3 style={{ color: 'white' }}>Manners</h3>:<h3 style={{ color: 'white' }}>Caring</h3>)}
                                    <div className='option' onClick={() => {settopic(index)}} role='button' style={conversationNum === 7 ? {marginTop: '0px'} : {}}>                                        
                                        <div className='text'>{topic.text}</div>
                                        <div className='icon'>
                                            <img alt='topic icon' src={topic.img} />
                                        </div>
                                        {topic.completed === 1 && <div className='optionProgress'>Completed</div>}                                 
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </div>}
            {displayStep3 && practice}
            {displayCoin && <Coin level={'LEVEL1'} coin={freeplay.level1Coin} close={() => {setDisplayCoin(false); setDisplayCelebrate(true)}}/>}
            {displayCelebrate && <Celebrate
              voice1={celebrateVoice}
              voice2={getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login)}
              text={celebrateText}
              name={`level1_celebration_${topicName}.mp4`}
              level1={true}
              animation={getVideo('appfiles/greet/greet_awesome_job.gif', login)}
              close={() => {updateProgress(); setDisplayCelebrate(false); setDisplayCoinAfterCelebrate(true)}}
            />}
            {displayCoinAfterCelebrate && <Coin level={'LEVEL1'} coin={freeplay.level1Coin} close={() => {setDisplayCoinAfterCelebrate(false); setDisplayGame(true)}}/>}
            {displayGame && <Game checkCompletion={checkCompletion} coin={freeplay.level1Coin} level={'LEVEL1'}/>}
            {displayAnimal && animal}
            {prize && (
                <img
                    className='present'
                    style={{
                    width: '84px',
                    height: '100px',
                    marginLeft: '-42px',
                    zIndex: 10,
                    }}
                    id='bounceIcons'
                    src={giftBtn}
                    alt='gift'
                    onClick={() => {
                        playSurpriseVideo();
                        setPrize(false);
                        sleep(2000).then(() => {setDisplayStep1(true);});
                    }}
                />
            )}
            {prize && (
                <audio autoPlay>
                    <source src={presentSound}></source>
                </audio>
            )}   
                  
            {!displayDecorate && <div className='transparentArea'>
            </div>}
            <div className='decorateArea' style={{zIndex : change ? 1 : 0}}>
                {change && <div className="text">Drag and drop your item</div>}
                <img
                    className='confirmDecorate'
                    style={{opacity : change ? 1 : 0, pointerEvents : change ? "auto" : "none"}}
                    src={greenCheck}
                    alt='confirm button'
                    onClick={()=>{greenCheckSound.play(); setChange(false); setUpdate(!update)}}
                />
                {boughts.map((bought, index) => (
                    <Draggable
                        key={index}
                        disabled={!displayDecorate}
                        bounds='parent'
                        position={{
                        x: bought.position.x * clientWidth,
                        y: bought.position.y * clientHeight,
                        }}
                        onStart={()=>{setChange(true);}}
                        onStop={(e, data) => {
                            onStop(bought, data);
                        }}
                    >
                    {bought.url.includes("https:") ?
                        <div className={`item ${bought.name}`}>
                            <img alt='reward' draggable="false" src={bought.url}/>
                        </div>
                        :
                        <div className={`item ${bought.name}`}>
                            <img alt='reward' draggable="false" src={generateImageUrl(bought.url)}/>
                        </div>
                    }
                  </Draggable>
                ))}
            </div>
        </div>}
        </>
    );
};
export default Level1;
